import React from 'react';
import { createContext } from '@shared/utils/createContext';
import {
  useGetCatalogProductGridItemsQuery,
  useGetCatalogProductGridItemsLazyQuery,
  useGetUniversalGridItemsQuery,
  useGetUniversalGridItemsLazyQuery,
  GetAllGridItemsQueryOptions,
  GetAllGridItemsQueryResult,
  GetAllGridItemsLazyQueryOptions,
  GetAllGridItemsLazyQueryResult
} from '../../../../api/queries/getAllProductGridItems';
import { useUniversalSearchFeature } from '../../../../hooks/useUniversalSearchFeature';

type SearchProductsProviderResult = {
  useGetGridItemsQuery: (options: GetAllGridItemsQueryOptions) => GetAllGridItemsQueryResult;
  useGetGridItemsLazyQuery: (options: GetAllGridItemsLazyQueryOptions) => GetAllGridItemsLazyQueryResult;
};

const SEARCH_PRODUCTS_CONTEXT_DEFAULT: SearchProductsProviderResult = {
  useGetGridItemsQuery: () => ({ loading: true, productList: [] }),
  useGetGridItemsLazyQuery: () => ({ loading: true, fallbackProductList: [], sendRequest: () => {} })
};

const [Provider, useProvider] = createContext<SearchProductsProviderResult>({ name: 'SearchProducts', initialValue: SEARCH_PRODUCTS_CONTEXT_DEFAULT });

const CatalogSearchProductsProvider: React.FC = props => {
  const result: SearchProductsProviderResult = {
    useGetGridItemsQuery: useGetCatalogProductGridItemsQuery,
    useGetGridItemsLazyQuery: useGetCatalogProductGridItemsLazyQuery
  };

  return <Provider value={result}>{props.children}</Provider>;
};

const UniversalSearchProductsProvider: React.FC = props => {
  const result: SearchProductsProviderResult = {
    useGetGridItemsQuery: useGetUniversalGridItemsQuery,
    useGetGridItemsLazyQuery: useGetUniversalGridItemsLazyQuery
  };

  return <Provider value={result}>{props.children}</Provider>;
};

export const useSearchProductsProvider = useProvider;
export const SearchProductsProvider: React.FC = props => {
  const { isUserExposedToUniversalSearchFeature, universalCatalogMeshEnabled, loading } = useUniversalSearchFeature();

  if (loading) {
    return <Provider value={SEARCH_PRODUCTS_CONTEXT_DEFAULT}>{props.children}</Provider>;
  }
  if (isUserExposedToUniversalSearchFeature && universalCatalogMeshEnabled) {
    return <UniversalSearchProductsProvider {...props} />;
  }
  return <CatalogSearchProductsProvider {...props} />;
};
